"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ZoomCredential_1 = __importDefault(require("../../zoomCredential/ZoomCredential"));
require("./collectionSingleCredential.scss");
const CollectionSingleCredential = (props) => {
    const credential = props.credential;
    const design = props.credential.design;
    const badgeDesign = props.credential.badgeDesign;
    const { innerWidth } = window;
    return (react_1.default.createElement("div", { id: "collection-single-credential", className: "flex-colum" },
        react_1.default.createElement("div", { className: "top flex-row jc-c ai-c" }, badgeDesign ? (react_1.default.createElement(ZoomCredential_1.default, { height: props.isMobile ? 215 : 173, width: props.isMobile ? innerWidth : 245, design: badgeDesign, isBadge: true })) : design ? (react_1.default.createElement(ZoomCredential_1.default, { height: props.isMobile ? 215 : 173, width: props.isMobile ? innerWidth : 245, design: design, isBadge: false })) : ("")),
        react_1.default.createElement("div", { className: "bottom" },
            react_1.default.createElement("span", { className: "credential-name" }, !credential ? "" : credential.detailTitle))));
};
exports.default = CollectionSingleCredential;
